import { FieldValues, Path } from "react-hook-form";

import {
  Field,
  FieldHelper,
  FieldLabel,
  LabelRow,
} from "../../../components/FormPanel";
import { FormMoneyInput, SelectForm } from "../../../components/Input";
import {
  CASHBACK_AMOUNT_LABEL,
  CASHBACK_SOURCE_HELPER,
  CASHBACK_SOURCE_LABEL,
} from "./constants";
import { cashbackRule, cashbackSourceRule } from "./tradeValidation";
import {
  CashbackFundingFieldsProps,
  CashbackFundingFormValues,
  ChargeFormValues,
} from "./types";

// Shared by the buy and correction panels so the cashback pair can't drift between them.
export const CashbackFundingFields = <
  T extends FieldValues & CashbackFundingFormValues & ChargeFormValues,
>({
  idPrefix,
  control,
  sourceOptions,
  amountHelper,
  isSubmitting,
}: CashbackFundingFieldsProps<T>) => (
  <>
    <Field>
      <LabelRow>
        <FieldLabel htmlFor={`${idPrefix}-cashback`}>
          {CASHBACK_AMOUNT_LABEL}
        </FieldLabel>
      </LabelRow>
      <FormMoneyInput
        id={`${idPrefix}-cashback`}
        name={"cashbackEur" as Path<T>}
        control={control}
        rules={{ validate: cashbackRule }}
        disabled={isSubmitting}
        placeholder="0.00"
      />
      <FieldHelper>{amountHelper}</FieldHelper>
    </Field>

    <Field>
      <LabelRow>
        <FieldLabel htmlFor={`${idPrefix}-cashback-source`}>
          {CASHBACK_SOURCE_LABEL}
        </FieldLabel>
      </LabelRow>
      <SelectForm
        id={`${idPrefix}-cashback-source`}
        testId={`${idPrefix}-cashback-source`}
        name="cashbackSource"
        control={control}
        rules={{ validate: cashbackSourceRule }}
        options={sourceOptions}
        required={false}
        disabled={isSubmitting}
      />
      <FieldHelper>{CASHBACK_SOURCE_HELPER}</FieldHelper>
    </Field>
  </>
);
